import { Uuid } from "@/domains/global/identifiers";
import type { AssistantFollowUpModelData } from "@/store/assistant/types";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { computed, makeObservable, observable } from "mobx";

export class AssistantFollowUpObservable extends BaseSyncModel<AssistantFollowUpModelData> {
  public modelKind = SyncModelKind.AssistantFollowUp;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<AssistantFollowUpModelData> } & WithAppStore) {
    super({ id, data, store });
    makeObservable(this, {
      modelKind: observable,
      assistantId: computed,
      projectId: computed,
      taskId: computed,
      sourceContextId: computed,
      content: computed,
      status: computed,
      scheduledFor: computed,
      firedAt: computed,
      completedAt: computed,
      commitmentKind: computed,
      dueAt: computed,
      deadlineAt: computed,
      triggerType: computed,
      triggerNotBefore: computed,
      triggerNotAfter: computed,
      createdAt: computed,
      updatedAt: computed,
    });
  }

  get assistantId(): Uuid {
    return this.modelData.assistant_id;
  }

  get projectId(): Uuid | null {
    return this.modelData.project_id;
  }

  get taskId(): Uuid | null {
    return this.modelData.task_id;
  }

  get sourceContextId(): Uuid | null {
    return this.modelData.source_context_id;
  }

  get content(): string {
    return this.modelData.content;
  }

  get status(): string {
    return this.modelData.status;
  }

  get scheduledFor(): string {
    return this.modelData.scheduled_for;
  }

  get firedAt(): string | null {
    return this.modelData.fired_at;
  }

  get completedAt(): string | null {
    return this.modelData.completed_at;
  }

  get commitmentKind(): string | null {
    return this.modelData.commitment_kind;
  }

  get dueAt(): string | null {
    return this.modelData.due_at;
  }

  get deadlineAt(): string | null {
    return this.modelData.deadline_at;
  }

  get triggerType(): string | null {
    return this.modelData.trigger_type;
  }

  get triggerNotBefore(): string | null {
    return this.modelData.trigger_not_before;
  }

  get triggerNotAfter(): string | null {
    return this.modelData.trigger_not_after;
  }

  get createdAt(): string {
    return this.modelData.created_at;
  }

  get updatedAt(): string {
    return this.modelData.updated_at;
  }
}
